<template>
    <component :is="layout">
      <slot />
    </component>
</template>

<script>
// https://itnext.io/vue-tricks-smart-layouts-for-vuejs-5c61a472b69b
// https://blog.izem.dev/a-vue-3-users-guide-to-creating-complex-layouts
import { computed } from 'vue'
import { useRoute } from 'vue-router'
import AppLayoutNull from '@/layout/nulled.vue';
import AppLayoutDefault from '@/layout/index.vue';
import AppLayoutLogin from '@/layout/login.vue';

export default {
    name: 'AppLayout',
    setup() {
        const route = useRoute();
        const layout = computed(() => {
            const layout = route?.meta?.layout;
            //console.log(layout);
            //return AppLayoutLogin;
            if (!layout) {
                return AppLayoutNull;
            }
            if (layout == "login") {
                return AppLayoutLogin;
            } else {
                return AppLayoutDefault;
            }
        });
        
        return { layout }
    }
}
</script>